import type { Tokens } from '@zeus/themes';

export function createShape(tokens: Tokens) {
  return {
    borderRadius: tokens.shape.borderRadius,
    borderRadiusMd: tokens.shape.borderRadiusMd,
    borderRadiusLg: tokens.shape.borderRadiusLg,
    borderRadiusFull: tokens.shape.borderRadiusFull,
  };
}
